import { useCallback, useEffect, useState } from 'react'
import { Users } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { CarteirasPanel } from '@/components/tasks/board/CarteirasPanel'
import { useAuth } from '@/contexts/AuthContext'
import { isSocio } from '@/lib/roles'
import { taskBoardService, type Carteira } from '@/services/task-board-service'
import { apiErrorMessage, teamService, type TeamMember } from '@/services/team-service'

/** Configurações › Carteiras: grupos de pessoas que filtram as tarefas (só sócio altera). */
export function CarteirasSettingsPage() {
  const { user } = useAuth()
  const [carteiras, setCarteiras] = useState<Carteira[]>([])
  const [members, setMembers] = useState<TeamMember[]>([])
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(() => {
    taskBoardService.listCarteiras()
      .then((list) => { setCarteiras(list); setError(null) })
      .catch((err) => setError(apiErrorMessage(err, 'Não foi possível carregar as carteiras')))
  }, [])

  useEffect(() => {
    load()
    teamService.listMembers().then((list) => setMembers(list.filter((m) => m.isActive))).catch(() => setMembers([]))
  }, [load])

  return (
    <div className="flex flex-col gap-6 p-4 sm:p-6">
      <div className="flex items-center gap-2">
        <Users className="size-6 text-muted-foreground" />
        <h1 className="text-2xl font-semibold">Carteiras</h1>
      </div>
      {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
      <Card>
        <CardHeader>
          <CardTitle>Carteiras de tarefas</CardTitle>
          <CardDescription>Ex.: Paulo + Bruno. Filtram as vistas de Prazos e tarefas.</CardDescription>
        </CardHeader>
        <CardContent>
          <CarteirasPanel carteiras={carteiras} members={members} canEdit={isSocio(user?.role)} onChanged={load} />
        </CardContent>
      </Card>
    </div>
  )
}
